import {
    apiRequest,
    pendidikanDetail,
    pendidikanUpdate
} from "../../../../../services/adapters/kepegawaian/pendidikanService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pendidikanDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", pendidikanUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository